function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 8078",
  transform: "translate(-462 -529)"
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 171",
  cx: 35,
  cy: 35,
  r: 35,
  transform: "translate(462 529)",
  fill: "#e8f6f4"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Icon ionic-ios-card",
  fill: "#a1dbd3"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2030",
  d: "M517.314 552.88a2.888 2.888 0 00-2.88-2.88H479.88a2.888 2.888 0 00-2.88 2.88v4.319h40.314z"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 2031",
  d: "M477 575.916a2.888 2.888 0 002.88 2.88h34.554a2.888 2.888 0 002.88-2.88v-14.398H477zm12.778-4.319h14.758a1.264 1.264 0 011.26 1.26 1.264 1.264 0 01-1.26 1.26h-14.758a1.264 1.264 0 01-1.26-1.26 1.264 1.264 0 011.26-1.261zm-6.479 0h1.08a1.264 1.264 0 011.26 1.26 1.264 1.264 0 01-1.26 1.26h-1.08a1.264 1.264 0 01-1.26-1.26 1.264 1.264 0 011.26-1.261z"
})));
const SvgCreditCardCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 70 70"
}, props), _ref);
export default SvgCreditCardCircle;